module.exports = __webpack_public_path__ + "images/cebsb_logo.1789354321160.png";